import QRCode from 'qrcode';

export async function generateQRDataUri(text: string): Promise<string> {
  return QRCode.toDataURL(text, {
    width: 80,
    margin: 1,
    color: { dark: '#1f2937', light: '#ffffff' },
  });
}
